import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Fancybox as NativeFancybox } from '@fancyapps/ui/dist/fancybox.esm.js'
import './style.css'

function Fancybox(props) {
  const delegate = props.delegate || '[data-fancybox]'

  useEffect(() => {
    const opts = props.options || {}

    NativeFancybox.bind(delegate, opts)

    return () => {
      NativeFancybox.destroy()
    }
  }, [])

  return <>{props.children}</>
}

Fancybox.propTypes = {
  delegate: PropTypes.string,
  options: PropTypes.object,
  children: PropTypes.object,
}

export default Fancybox
